import { render, staticRenderFns } from "./PFForfeitureConfirmData.vue?vue&type=template&id=35a329ef"
import script from "./PFForfeitureConfirmData.vue?vue&type=script&lang=js"
export * from "./PFForfeitureConfirmData.vue?vue&type=script&lang=js"
import style0 from "./PFForfeitureConfirmData.vue?vue&type=style&index=0&id=35a329ef&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports